import React from 'react'
import {Link} from "react-router-dom";
import logo from "./../../../../src/resources/images/logo.png"

export const Footer = () =>{

    return(
        <div className="footer-block">
            <div className="container pt-5 mb-5">
                <div className="row">
                    <div className="col-3 py-4">
                        <Link to="/">
                            <img src={logo} className="w-75 my-auto"/>
                        </Link>
                    </div>
                    <div className="col-3">
                        <p className="footer-block_p__headerName mb-4">О компании</p>
                        <Link to="/" className="footer-block_p__headerMenu">
                            <p className="mb-1">О нас</p>
                        </Link>
                        <Link to="/" className="footer-block_p__headerMenu">
                            <p>Контакты</p>
                        </Link>
                    </div>
                    <div className="col-3">
                        <p className="footer-block_p__headerName mb-4">Информация</p>
                        <Link to="/" className="footer-block_p__headerMenu">
                            <p className="mb-1">Политика Конфиденциальности</p>
                        </Link>
                        <Link to="/" className="footer-block_p__headerMenu">
                            <p className="mb-1">Часто задаваемые вопросы</p>
                        </Link>
                        <Link to="/" className="footer-block_p__headerMenu">
                            <p>Возврат и обмен</p>
                        </Link>
                    </div>
                    <div className="col-3">
                        <p className="footer-block_p__headerName mb-4">Свяжитесь с нами</p>
                        <a href="tel:+998712026500" className="footer-block_a__headerMenu">+998 71 202 65 00</a>
                        <p className="footer-block_p__headerMenuFooter mt-3">Следите за нами</p>
                        <button className="btn footer-block_div__followIcon">
                            <i className="fa fa-facebook"></i>
                        </button>
                        <button className="btn footer-block_div__followIcon footer-block_div__followIcon__colorSecond">
                            <i className="fa fa-instagram"></i>
                        </button>
                        <button className="btn footer-block_div__followIcon footer-block_div__followIcon__colorThird">
                            <i className="fa fa-telegram"></i>
                        </button>
                        <button className="btn footer-block_div__followIcon footer-block_div__followIcon__colorFourth">
                            <i className="fa fa-twitch"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}